import React, {useRef} from 'react';
import {setLearnIsActive} from "../../../../Features/Misc/navBarSlice";
import Slider from "react-slick";
import learnSettings from "../SliderSettings/learnSettings";
import FaveLearnCard from "../FaveLearn/FaveLearnCard";
import FaveLearnButtonSet from "../FaveLearn/FaveLearnButtonSet";
import {v4 as uuidv4} from "uuid";
import {useDispatch, useSelector} from "react-redux";

const LearnSection = () => {
    const dispatch = useDispatch()
    const learnSlider = useRef()


    const { learns } = useSelector((state) => state.learns)
    const { faveLearns } = useSelector((state) => state.fave)
    const { faveOffCanvasToggled } = useSelector((state) => state.navBar)

    const parsedFaveLearns = faveLearns ? Object.values(faveLearns).map(faveLearn => parseInt(faveLearn)) : [];
    const filteredLearns = parsedFaveLearns && learns.filter(learn => parsedFaveLearns.includes(learn.id));

    const getNextLearnSlide = (c) =>{
        learnSlider.current.slickNext(c);
    }

    const getPrevLearnSlide = (c) =>{
        learnSlider.current.slickPrev(c);
    }

    let navText = "Learn"
    let navIcon = "ri-book-read-line mr-2 text-pink-icon"

    return (
        <>
        {!faveOffCanvasToggled &&
    <div className={`learnFavourites  ${!filteredLearns[0] ? " hidden " : " "} flex flex-col sm:flex-row mb-6 sm:m-0`}>
        <div
            className=" mb-4 sm:h-100 w-full sm:w-2/12 pl-0 sm:pl-2 3xl:pl-6 items-between justify-between sm:justify-center gap-8 flex  flex-row sm:flex-col text-xl pr-4">


            <div className="flex flex-row gap-2 items-center text-2xl">
                <i className={` ${navIcon} `}  ></i>
                <div>{navText}</div>
            </div>

            <div className={`text-base flex items-center cursor-pointer hover:opacity-60 transition-opacity duration-200`}>
                <div onClick={() => dispatch(setLearnIsActive())}>View all</div>
            </div>

            {!faveOffCanvasToggled &&
                <FaveLearnButtonSet
                    customStyles={`hidden buttonSet sm:flex flex row gap-4 text-pink-icon`}
                    getPrevLearnSlide={getPrevLearnSlide}
                    getNextLearnSlide={getNextLearnSlide}
                />
            }

        </div>


        <div className="learnFavourites h-1/3 w-full sm:w-10/12 mb-6 ">

            <Slider ref={(c) => (learnSlider.current = c)} {...learnSettings} key={filteredLearns && filteredLearns.length}>
                {filteredLearns && filteredLearns.map((learn) => {

                    const { title, content} = learn

                    return <FaveLearnCard
                        imgSrc={learn?._embedded?.["wp:featuredmedia"]?.[0]?.source_url}
                        favourite={true}
                        title={title?.rendered}
                        text={content?.rendered}
                        vidLink={learn?.acf?.video_url}
                        key={uuidv4()}
                        mediaType={learn?.type}
                        mediaId={learn?.id}
                        vidLink={learn?.acf?.video_network === "vimeo" ? learn?.acf?.vimeo_url ?? null : learn?.acf?.youtube_url ?? null}
                        orientation={learn?.acf?.orientation ?? null}
                    />

                })}

            </Slider>

        </div>

        {!faveOffCanvasToggled &&
            <FaveLearnButtonSet
                customStyles={`buttonSet sm:hidden flex row gap-4 text-pink-icon justify-center sm:m-0`}
                getPrevLearnSlide={getPrevLearnSlide}
                getNextLearnSlide={getNextLearnSlide}
            />
        }

    </div>
}

   </> );
};

export default LearnSection;